/**
 * Builds navigation state for the Positions list page.
 * PositionList resets all filters to default before applying this state,
 * so pass only the filter(s) you want to set; all others are cleared.
 *
 * Supported overrides:
 * - mc: 'large' | 'mid' | 'low'  — market cap filter
 * - groupName: string            — group filter (use 'Ungrouped' for none)
 * - locationName: string         — location filter (use 'Unlocated' for none)
 * - exitStrategyFilter: '' | 'unset' | 'set' | 'approaching' | 'triggered'
 * - invalidationFilter: '' | 'unset' | 'set' | 'approaching' | 'triggered'
 *
 * @param {Object} overrides - Only the filter keys you want to apply
 * @returns {Object} State to pass to navigate('/positions', { state })
 */
export function positionsListNavState(overrides = {}) {
  return { ...overrides };
}
